import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {MerchantsState, getInitialState} from '@web/slices/merchants/slice'

import {MakeSliceOptions, MerchantsReducers} from './interfaces'

export default (options?: MakeSliceOptions) =>
    createSlice<MerchantsState, MerchantsReducers, 'merchants', SliceSelectors<MerchantsState>>({
        name: 'merchants',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            options?.extraReducers?.(builder)
            builder.addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                return payload.merchants ?? state
            })
        },
    })
